var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3365 68.8555C70.1648 68.8555 81.3749 57.6454 81.3749 43.8171C81.3749 29.9889 70.1648 18.7788 56.3365 18.7788C42.5083 18.7788 31.2982 29.9889 31.2982 43.8171C31.2982 57.6454 42.5083 68.8555 56.3365 68.8555Z",
    stroke: "#6B7280",
    strokeWidth: 12.5192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.413 131.451V118.932C106.413 112.292 103.775 105.923 99.0791 101.227C94.3835 96.5318 88.0149 93.8938 81.3743 93.8938H31.2977C24.6571 93.8938 18.2885 96.5318 13.5929 101.227C8.8973 105.923 6.25934 112.292 6.25934 118.932V131.451",
    stroke: "#6B7280",
    strokeWidth: 12.5192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.413 62.5964C116.784 62.5964 125.192 54.1889 125.192 43.8177C125.192 33.4465 116.784 25.0389 106.413 25.0389C96.042 25.0389 87.6345 33.4465 87.6345 43.8177C87.6345 54.1889 96.042 62.5964 106.413 62.5964Z",
    stroke: "#6B7280",
    strokeWidth: 12.5192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulations);
export default __webpack_public_path__ + "static/media/populations.587c574d44fee7b001b0870cae0b0a3e.svg";
export { ForwardRef as ReactComponent };